import React from 'react';
import { useLocation, useMatch, Link } from '@reach/router';
import queryString from 'query-string';
import Icons from 'components/Icons';
import {
  settingsSetup,
  settingsConfigure,
  userMgmtGroup,
  subscriberConfigure
} from 'screens/settings/constants';
import { StyledBreadcrumb } from './style';
import i18n from '../../i18n';
const trans = i18n.t;
const settingsList = [
  ...settingsSetup,
  ...settingsConfigure,
  ...userMgmtGroup,
  ...subscriberConfigure
];

const getBreadcrumbConfig = type => [
  {
    id: '/admin/status-customize',
    label: trans('components.globalTopNav.statusPageCustomization'),
    children: [
      {
        id: '/admin/status-customize/advanced',
        label: 'Look and feel'
      }
    ]
  },
  {
    id: '/admin/incidents/public',
    label: trans('components.globalTopNav.incidents')
  },
  {
    id: '/admin/incidents/planned',
    label: trans('components.globalTopNav.maintenance')
  },
  {
    id: '/admin/incidents/announcement',
    label: trans('components.globalTopNav.announcement')
  },
  {
    id: '/admin/incidents',
    label: type === 'planned' ? trans('components.globalTopNav.maintenance') : trans('components.globalTopNav.incidents'),
    children: [
      {
        id: '/admin/incidents/create',
        label: trans('components.globalTopNav.new')
      }
    ]
  },
  {
    id: '/admin/reports',
    label: trans('components.globalTopNav.reports')
  },
  {
    id: '/admin/quick-status',
    label: trans('components.globalTopNav.quickStatusActivityLog')
  },
  {
    id: '/admin/settings',
    label: trans('components.globalTopNav.settings'),
    children: settingsList.map(setting => ({
      id: `/admin/settings${setting.url}`,
      label: setting.label,
      subChildren:
        setting.subChildren &&
        setting.subChildren.map(subSetting => ({
          id: `/admin/settings${setting.url}${subSetting.url}`,
          label: subSetting.label
        }))
    }))
  },
  {
    id: '/admin/explore',
    label: trans('components.globalTopNav.explore')
  },
  {
    id: '/admin/service-customize',
    label: trans('components.globalTopNav.serviceComponents')
  },
  {
    id: '/admin/status-embed',
    label: trans('components.globalTopNav.statusEmbed'),
    children: [
      {
        id: '/admin/status-embed/badge',
        label: trans('components.globalTopNav.badge')
      },
      {
        id: '/admin/status-embed/alert-widget',
        label: trans('components.globalTopNav.alertWidget')
      }
    ]
  }
];

type BreadcrumbProps = {
  pageName: string
};

const Breadcrumb = ({ pageName }: BreadcrumbProps) => {
  const { pathname, state, search } = useLocation();
  const { type } = queryString.parse(search || '');
  // hack to handle dynamic route matches
  const isIncidentView = useMatch('/admin/incidents/:type/:id');

  const page = getBreadcrumbConfig(type).find(
    config => pathname.indexOf(config.id) === 0
  );
  const child =
    page && page.children
      ? page.children.find(config => pathname.indexOf(config.id) === 0)
      : null;

  const subChild =
    child && child.subChildren
      ? child.subChildren.find(config => pathname.indexOf(config.id) === 0)
      : null;
  return (
    <StyledBreadcrumb>
      {pageName ? (
        <>
          <Link to="/admin/incidents/public" className="homelink">
            <span>{pageName}</span>
          </Link>
          <span className="breadcrumb-separator">
            <Icons
              glyph="arrowdown"
              size="14"
              viewBox="3 0 32 32"
              style={{ transform: 'rotate(-90deg)' }}
            />
          </span>
        </>
      ) : null}
      {page ? (
        <>
          {child || isIncidentView ? (
            <Link
              to={type ? `${page.id}/${type}` : page.id}
              className="homelink"
            >
              <span>{page.label}</span>
            </Link>
          ) : (
            <span>{page.label}</span>
          )}
          <>
            {(child || isIncidentView) && (
              <>
                <span className="breadcrumb-separator">
                  <Icons
                    glyph="arrowdown"
                    size="14"
                    viewBox="3 0 32 32"
                    style={{ transform: 'rotate(-90deg)' }}
                  />
                </span>
                {child ? (
                  subChild ? (
                    <Link to={child.id} className="homelink">
                      <span>{child.label}</span>
                    </Link>
                  ) : (
                    <span className="leaf-node">{child.label}</span>
                  )
                ) : (
                  isIncidentView && (
                    <span>
                      {isIncidentView.id === 'edit'
                        ? state
                          ? `${state.is_planned ? '#SM' : '#INC'}${
                              isIncidentView.type
                            }`
                          : `Edit #${isIncidentView.type}`
                        : `#${
                            isIncidentView.type === 'planned' ? 'SM' : 'INC'
                          }${isIncidentView.id}`}
                    </span>
                  )
                )}
                {subChild && (
                  <>
                    <span className="breadcrumb-separator">
                      <Icons
                        glyph="arrowdown"
                        size="14"
                        viewBox="3 0 32 32"
                        style={{ transform: 'rotate(-90deg)' }}
                      />
                    </span>
                    {/* <Link to={subChild.id}> */}
                    <span className="leaf-node">{subChild.label}</span>
                    {/* </Link> */}
                  </>
                )}
              </>
            )}
          </>
        </>
      ) : (
        trans('components.globalTopNav.status')
      )}
    </StyledBreadcrumb>
  );
};

export default Breadcrumb;
